<template>
  <div class="accordion">
    <div class="body" :class="{ 'accordion-showing': show }">
      <div class="flex flex-between">
        <div class="content">
          <h3 @click="toggle" class="cursor-pointer">{{category.title}}
            <img :src="`/images/icons/${show ? 'minus-white' : 'plus-white'}.svg`" class="mobile" />
          </h3>
          <app-expandable>
            <div v-show="show" class="expandable">
              <p>{{category.description}}</p>
              <a :href="category.url" class="button">View ranges</a>
            </div>
          </app-expandable>
        </div>
        <app-expandable>
          <div v-show="show" class="image expandable">
            <img :src="category.image" width="100%" height="auto" />
          </div>
        </app-expandable>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'category'
  ],

  data () {
    return {
      show: false,
      leaving: false,
    }
  },

  mounted() {
  },

  // computed: {
  //   show: {
  //     get () {
  //       return this.value
  //     },

  //     set (value) {
  //       this.$emit('input', value)
  //     },
  //   }
  // },

  methods: {
    toggle () {
      this.show = ! this.show
    },
    // enter (el, done) {
    //   $(el).slideDown(150, done)
    // },
    // leave (el, done) {
    //   $(el).slideUp(150, done)
    // },
    beforeEnter (el) {
      el.style.height = '0'
    },
    enter (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    beforeLeave (el) {
      el.style.height = el.scrollHeight + 'px'
      this.leaving = true
    },
    afterLeaving () {
      this.leaving = false
    },
    leave (el) {
      el.style.height = '0'
    }
  }
}
</script>

<style lang="scss" scoped>
    img {
      @media (min-width: 1024px){
        margin-top: 10px;
      }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Accordion.vue